<template>
	<R3Modal v-model:visible="visible" class="r3-modal-motion m-4">
		<div class="flex flex-row align-items-center justify-content-end">
			<R3Button icon="pi pi-times" @click="closeDialog" />
		</div>

		<div class="flex flex-row align-items-center justify-content-center mt-6">

			<R3Button label="Escanear QRCode de configuração de servidor" @click="scanBarcode">

			</R3Button>
		</div>


	</R3Modal>
</template>

<script setup lang="ts">

	import { CapacitorBarcodeScanner } from "@capacitor/barcode-scanner";
	import z from "zod";
	import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
	import { computed } from "vue";

	const { msgDlg } = useMessageDlg();

	const props = defineProps<{ visible: boolean }>();
	const emit = defineEmits<{ (event: "close"): void; (event: "update:visible", value: boolean): void }>();

	const visible = computed({
		get: () => props.visible,
		set: (value: boolean) => emit("update:visible", value),
	});

	function closeDialog() {
		visible.value = false;
		emit("close");
	}

	async function scanBarcode() {

		const barcodeContent = await CapacitorBarcodeScanner.scanBarcode({
			hint: 0,
			// scanButton: true
		});



		if (!barcodeContent.ScanResult) {
			await msgDlg(
				"Leitura Cancelada",
				"informa",
				"A leitura do QR code foi cancelada. Por favor, tente novamente.",
				["ok"]
			);
			return;
		}

		const connectionConfig = await parseConnectionConfig(barcodeContent.ScanResult);
		if (!connectionConfig) return;


		await Filesystem.writeFile({
			path: "secrets/connectionConfig.json",
			data: JSON.stringify(connectionConfig),
			directory: Directory.Cache,
			encoding: Encoding.UTF8,
			recursive: true
		});

		await msgDlg(
			"Configuração de Conexão Recebida",
			"informa",
			"Configuração de conexão recebida com sucesso. A aplicação agora tentará se conectar utilizando as informações fornecidas.",
			["ok"]
		);

		closeDialog();

	}

	async function parseConnectionConfig(content: string) {
		const connectionConfigSchema = z.object({
			url: z.string(),
			port: z.coerce.number(),
		})

		let parsedContent: unknown;

		try {
			parsedContent = JSON.parse(content);
		} catch (error) {
			await msgDlg(
				"Conteúdo Inválido",
				"informa",
				"O QR code escaneado não contém um conteúdo válido. Por favor, verifique o QR code e tente novamente.",
				["ok"]
			);
			return null;
		}

		const parseResult = connectionConfigSchema.safeParse(parsedContent);
		if (!parseResult.success) {
			console.error("Erro ao parsear configuração de conexão: ", parseResult.error);
			await msgDlg(
				"Configuração de Conexão Inválida",
				"informa",
				"O QR code escaneado contém uma configuração de conexão inválida. Por favor, verifique o conteúdo e tente novamente.",
				["ok"]
			);
			return null;
		}

		return parseResult.data;
	}

</script>

<style lang="scss" scoped></style>